(function () {
  var THRESHOLD_CENTS = 60000;
  var PROMOTION_TYPE = 'wfd_promotion';
  var isRunning = false;

  function fetchJson(url, options) {
    return fetch(url, options).then(function (res) {
      return res.text().then(function (text) {
        var data;

        try {
          data = JSON.parse(text);
        } catch (err) {
          throw new Error('Non-JSON response from ' + url + ': ' + text.slice(0, 80));
        }

        if (!res.ok) {
          throw new Error('HTTP ' + res.status + ' from ' + url);
        }

        return data;
      });
    });
  }

  function getCart() {
    return fetchJson('/cart.js', {
      credentials: 'same-origin',
      cache: 'no-store'
    });
  }

  function getFreeAttributes() {
    return {
      _seel_wfp_discount_info: JSON.stringify({
        promotion_type: PROMOTION_TYPE,
        merchant_discount: 100
      }),
      promotion_type: PROMOTION_TYPE,
      merchant_discount: '100'
    };
  }

  function getClearAttributes() {
    return {
      _seel_wfp_discount_info: '',
      promotion_type: '',
      merchant_discount: ''
    };
  }

  function updateCartAttributes(attributes) {
    return fetchJson('/cart/update.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        attributes: attributes
      })
    });
  }

  function isAlreadyCorrect(cart, attrs) {
    var current = cart && cart.attributes ? cart.attributes : {};

    return (
      String(current._seel_wfp_discount_info || '') === String(attrs._seel_wfp_discount_info || '') &&
      String(current.promotion_type || '') === String(attrs.promotion_type || '') &&
      String(current.merchant_discount || '') === String(attrs.merchant_discount || '')
    );
  }

  function parseMoneyValues(text) {
    var matches = String(text || '').match(/\$[\s]*[\d,]+(?:\.\d{1,2})?/g);

    if (!matches || !matches.length) return [];

    return matches
      .map(function (money) {
        var num = money.replace('$', '').replace(/,/g, '').trim();
        var cents = Math.round(parseFloat(num) * 100);
        return isNaN(cents) ? 0 : cents;
      })
      .filter(function (value) {
        return value > 0;
      });
  }

  function cleanCartTextRoot(root) {
    if (!root) return null;

    var clone = root.cloneNode(true);

    var removeSelectors = [
      '[class*="seel"]',
      '[id*="seel"]',
      '[data-seel]',
      '[data-seel-checkout]',
      '[data-seel-protection-checkout]',
      '[class*="worry"]',
      '[id*="worry"]',
      '[class*="protection"]',
      '[id*="protection"]'
    ];

    removeSelectors.forEach(function (selector) {
      clone.querySelectorAll(selector).forEach(function (node) {
        node.remove();
      });
    });

    clone.querySelectorAll('*').forEach(function (node) {
      var text = (node.innerText || node.textContent || '').toLowerCase();

      if (
        text.indexOf('worry-free') > -1 ||
        text.indexOf('worry free') > -1 ||
        text.indexOf('protection') > -1 ||
        text.indexOf('by seel') > -1 ||
        text.indexOf('checkout +') > -1 ||
        text.indexOf('checkout without') > -1
      ) {
        node.remove();
      }
    });

    return clone;
  }

  function getCartAmountFromPage() {
    var roots = [
      document.querySelector('form[action="/cart"]'),
      document.querySelector('#CartDrawer form'),
      document.querySelector('cart-drawer form'),
      document.querySelector('.cart-drawer form'),
      document.querySelector('#CartDrawer'),
      document.querySelector('cart-drawer'),
      document.querySelector('.cart-drawer'),
      document.querySelector('[id*="CartDrawer"]'),
      document.querySelector('[class*="cart-drawer"]'),
      document.querySelector('main'),
      document.body
    ].filter(Boolean);

    for (var i = 0; i < roots.length; i++) {
      var cleanRoot = cleanCartTextRoot(roots[i]);
      var text = cleanRoot ? (cleanRoot.innerText || cleanRoot.textContent || '') : '';
      var values = parseMoneyValues(text);

      if (values.length) {
        return Math.max.apply(null, values);
      }
    }

    return 0;
  }

  async function getEligibleState() {
    var amount = 0;
    var source = 'api';
    var cart = null;

    try {
      cart = await getCart();
      amount = Number(cart.items_subtotal_price || cart.total_price || 0);
    } catch (err) {
      source = 'page';
      amount = getCartAmountFromPage();
      console.warn('[Seel WFP] cart api failed, fallback to page amount:', err.message);
    }

    return {
      cart: cart,
      amount: amount,
      source: source,
      eligible: amount >= THRESHOLD_CENTS
    };
  }

  async function syncSeelWfpPromotion(options) {
    options = options || {};

    if (isRunning && !options.force) return;

    isRunning = true;

    try {
      var state = await getEligibleState();
      var attrs = state.eligible ? getFreeAttributes() : getClearAttributes();

      console.log('[Seel WFP] amount:', state.amount / 100);
      console.log('[Seel WFP] source:', state.source);
      console.log('[Seel WFP] eligible:', state.eligible);
      console.log('[Seel WFP] current attributes:', state.cart && state.cart.attributes ? state.cart.attributes : {});
      console.log('[Seel WFP] target attributes:', attrs);

      if (state.cart && isAlreadyCorrect(state.cart, attrs)) {
        console.log('[Seel WFP] attributes already correct');
        return {
          changed: false,
          eligible: state.eligible,
          amount: state.amount
        };
      }

      await updateCartAttributes(attrs);

      console.log('[Seel WFP] attributes updated');

      return {
        changed: true,
        eligible: state.eligible,
        amount: state.amount
      };
    } catch (err) {
      console.error('[Seel WFP] sync failed:', err);
      throw err;
    } finally {
      isRunning = false;
    }
  }

  function clearSeelWfpPromotion() {
    return updateCartAttributes(getClearAttributes());
  }

  function findCheckoutButton(target) {
    if (!target || !target.closest) return null;

    var direct = target.closest(
      [
        'button[name="checkout"]',
        'input[name="checkout"]',
        'a[href="/checkout"]',
        'a[href*="/checkout"]',
        '[data-checkout-button]',
        '[data-seel-checkout]',
        '[data-seel-protection-checkout]'
      ].join(',')
    );

    if (direct) return direct;

    var possible = target.closest('button, a, input, [role="button"], div');

    if (!possible) return null;

    var text = (
      possible.innerText ||
      possible.textContent ||
      possible.value ||
      ''
    ).toLowerCase();

    if (
      text.indexOf('checkout') > -1 &&
      (
        text.indexOf('protection') > -1 ||
        text.indexOf('worry-free') > -1 ||
        text.indexOf('worry free') > -1
      )
    ) {
      return possible;
    }

    return null;
  }

  function isWithoutProtectionButton(button) {
    var text = (
      button.innerText ||
      button.textContent ||
      button.value ||
      ''
    ).toLowerCase();

    return (
      text.indexOf('without protection') > -1 ||
      text.indexOf('no protection') > -1 ||
      text.indexOf('decline protection') > -1
    );
  }

  function setButtonLoading(button, loading, oldText) {
    if (!button) return;

    if ('disabled' in button) {
      button.disabled = loading;
    }

    if (loading) {
      if (button.innerText) {
        button.__seelOldText = oldText || button.innerText;
        button.innerText = 'Processing...';
      } else if (button.value) {
        button.__seelOldText = oldText || button.value;
        button.value = 'Processing...';
      }
    } else {
      var text = button.__seelOldText || oldText;

      if (text) {
        if (button.innerText) {
          button.innerText = text;
        } else if (button.value) {
          button.value = text;
        }
      }
    }
  }

  document.addEventListener(
    'click',
    async function (event) {
      var checkoutButton = findCheckoutButton(event.target);

      if (!checkoutButton) return;

      if (checkoutButton.dataset && checkoutButton.dataset.seelWfpSynced === 'true') {
        checkoutButton.dataset.seelWfpSynced = 'false';
        return;
      }

      event.preventDefault();
      event.stopImmediatePropagation();

      var oldText = checkoutButton.innerText || checkoutButton.value || '';

      try {
        setButtonLoading(checkoutButton, true, oldText);

        if (isWithoutProtectionButton(checkoutButton)) {
          await clearSeelWfpPromotion();
        } else {
          await syncSeelWfpPromotion({
            force: true
          });
        }

        if (checkoutButton.dataset) {
          checkoutButton.dataset.seelWfpSynced = 'true';
        }

        if (checkoutButton.tagName === 'A') {
          window.location.href = checkoutButton.href || '/checkout';
          return;
        }

        setButtonLoading(checkoutButton, false, oldText);

        checkoutButton.click();
      } catch (err) {
        console.error('[Seel WFP] checkout sync failed:', err);

        setButtonLoading(checkoutButton, false, oldText);

        window.location.href = '/checkout';
      }
    },
    true
  );

  window.SeelWfpFreePromotion = {
    sync: syncSeelWfpPromotion,
    clear: clearSeelWfpPromotion,
    getCart: getCart,
    getPageAmount: getCartAmountFromPage
  };
})();